


















































































import { Component, Vue, Prop } from 'vue-property-decorator';
import axios from 'axios';
import { api } from '@/api';

@Component
export default class SessionReportForm extends Vue {

    public note: string = '';

    public rating: number = 1;

    public sessionStartedAt: string = '';
    public sessionEndedAt: string = '';
    public errors: any = {};

    public processing: boolean = false;

    public get textFieldPropStartsAt(): any { 
        return {
            outlined: true,
            'error-messages': this.errors['session_started_at']
        }
    }
    public get textFieldPropEndsAt(): any { 
        return { 
            outlined: true,
            'error-messages': this.errors['session_ended_at']
        }
    }
    public timePickerProps: any = { format: "24hr", useSeconds: false };
    public datePickerProps: any = { }

    public getPayload(): any {
        
        return {
            babysitting_session_id: this.session.id,
            session_started_at: this.sessionStartedAt ? this.$moment(this.sessionStartedAt).format('YYYY-MM-DD, HH:mm') : null,
            session_ended_at: this.sessionEndedAt ? this.$moment(this.sessionEndedAt).format('YYYY-MM-DD, HH:mm') : null,
            note: this.note,
            rating: this.rating,
        };

    }

    public getPath(): string {

        if (!this.$store.state.auth.babysitter) return api.path('v1.admin.sessionReports');
        
        return api.path('v1.babysitter.sessionReports');
    }

    public $refs!: {
        form: HTMLFormElement // fix for this.$refs.form.valdiate(); TS error
    }

    @Prop() dialog!: boolean;
    @Prop() session!: any;

    public close() {

        this.$emit('update:dialog', !this.dialog);
        this.errors = {};
        this.$refs.form.reset();

    }

    public save() {

        /* if (!this.$refs.form.validate()) return; */
        this.processing = true;

        let apiPath = this.getPath();
        let payload = this.getPayload();

        axios.post(apiPath, payload)
            .then( res => {
                this.$toast.success(res.data.message);
                this.close();
            })
            .catch((error) => this.errors = error.response.data.errors)
            .finally(() => this.processing = false);
    }
}
